import React from 'react';

class CadastrarOrcamentoForm extends React.Component {

    render() {
        return(
            <div>
                <form id="cadastrar-orcamento-form">
                    <input type="text"
                        placeholder="Ano"
                        id="cadorcamento-ano"
                        value={ this.props.ano }
                        onChange={ this.props.changeAno } />
                    <span id="cadorcamento-total">
                        <b>Total: R$ { this.props.total }</b>
                    </span><br />
                    <table>
                        <tbody>
                            <tr>
                                <td>
                                    <label Style={ "font-family: Arial; font-size: 14px; color: #333333; float: left; margin-bottom: 3px;" }>Janeiro (R$): </label>
                                    <br />
                                    <input type="text"
                                        placeholder="Janeiro (R$)"
                                        className="cadorcamento-mes"
                                        value={ this.props.janeiro }
                                        onChange={ this.props.changeJaneiro } />
                                </td>
                                <td>
                                    <label Style={ "font-family: Arial; font-size: 14px; color: #333333; float: left; margin-bottom: 3px;" }>Fevereiro (R$): </label>
                                    <br />
                                    <input type="text"
                                        placeholder="Fevereiro (R$)"
                                        className="cadorcamento-mes"
                                        value={ this.props.fevereiro }
                                        onChange={ this.props.changeFevereiro } />
                                </td>
                                <td>
                                    <label Style={ "font-family: Arial; font-size: 14px; color: #333333; float: left; margin-bottom: 3px;" }>Março (R$): </label>
                                    <br />
                                    <input type="text"
                                        placeholder="Março (R$)"
                                        className="cadorcamento-mes"
                                        value={ this.props.marco }
                                        onChange={ this.props.changeMarco } />
                                </td>
                                <td>
                                    <label Style={ "font-family: Arial; font-size: 14px; color: #333333; float: left; margin-bottom: 3px;" }>Abril (R$): </label>
                                    <br />
                                    <input type="text"
                                        placeholder="Abril (R$)"
                                        className="cadorcamento-mes"
                                        value={ this.props.abril }
                                        onChange={ this.props.changeAbril } />
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <label Style={ "font-family: Arial; font-size: 14px; color: #333333; float: left; margin-bottom: 3px;" }>Maio (R$): </label>
                                    <br />
                                    <input type="text"
                                        placeholder="Maio (R$)"
                                        className="cadorcamento-mes"
                                        value={ this.props.maio }
                                        onChange={ this.props.changeMaio } />
                                </td>
                                <td>
                                    <label Style={ "font-family: Arial; font-size: 14px; color: #333333; float: left; margin-bottom: 3px;" }>Junho (R$): </label>
                                    <br />
                                    <input type="text"
                                        placeholder="Junho (R$)"
                                        className="cadorcamento-mes"
                                        value={ this.props.junho }
                                        onChange={ this.props.changeJunho } />
                                </td>
                                <td>
                                    <label Style={ "font-family: Arial; font-size: 14px; color: #333333; float: left; margin-bottom: 3px;" }>Julho (R$): </label>
                                    <br />
                                    <input type="text"
                                        placeholder="Julho (R$)"
                                        className="cadorcamento-mes"
                                        value={ this.props.julho }
                                        onChange={ this.props.changeJulho } />
                                </td>
                                <td>
                                    <label Style={ "font-family: Arial; font-size: 14px; color: #333333; float: left; margin-bottom: 3px;" }>Agosto (R$): </label>
                                    <br />
                                    <input type="text"
                                        placeholder="Agosto (R$)"
                                        className="cadorcamento-mes"
                                        value={ this.props.agosto }
                                        onChange={ this.props.changeAgosto } />
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <label Style={ "font-family: Arial; font-size: 14px; color: #333333; float: left; margin-bottom: 3px;" }>Setembro (R$): </label>
                                    <br />
                                    <input type="text"
                                        placeholder="Setembro (R$)"
                                        className="cadorcamento-mes"
                                        value={ this.props.setembro }
                                        onChange={ this.props.changeSetembro } />
                                </td>
                                <td>
                                    <label Style={ "font-family: Arial; font-size: 14px; color: #333333; float: left; margin-bottom: 3px;" }>Outubro (R$): </label>
                                    <br />
                                    <input type="text"
                                        placeholder="Outubro (R$)"
                                        className="cadorcamento-mes"
                                        value={ this.props.outubro }
                                        onChange={ this.props.changeOutubro } />
                                </td>
                                <td>
                                    <label Style={ "font-family: Arial; font-size: 14px; color: #333333; float: left; margin-bottom: 3px;" }>Novembro (R$): </label>
                                    <br />
                                    <input type="text"
                                        placeholder="Novembro (R$)"
                                        className="cadorcamento-mes"
                                        value={ this.props.novembro }
                                        onChange={ this.props.changeNovembro } />
                                </td>
                                <td>
                                    <label Style={ "font-family: Arial; font-size: 14px; color: #333333; float: left; margin-bottom: 3px;" }>Dezembro (R$): </label>
                                    <br />
                                    <input type="text"
                                        placeholder="Dezembro (R$)"
                                        className="cadorcamento-mes"
                                        value={ this.props.dezembro }
                                        onChange={ this.props.changeDezembro } />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <textarea placeholder="Comentário"
                        value={ this.props.comentario }
                        onChange={ this.props.changeComentario }></textarea><br /><br />
                    <button type="button" id="cadorcamento-cadastrar-btn" onClick={ this.props.cadastrar }>
                        Cadastrar
                    </button>
                    <button type="button" id="cadorcamento-cancelar-btn" onClick={ this.props.cancelar }>
                        Cancelar
                    </button>
                    <br /><br />
                </form>
            </div>
        );
    }

}

export default CadastrarOrcamentoForm;

